module.exports = __webpack_public_path__ + "414ba0781bb88b4bb7a78bbf0da7d211.png";